<div class="dialog-header">
  <div class="header-title">
    <span class="title-span">Hidden Cabinets</span>
  </div>
  <button mat-button [tabindex]="-1" class="close-button-container" (click)="onClose()" disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="dialog-content">
  <div class="loading-container" *ngIf="isLoading">
    <lib-progress-spinner></lib-progress-spinner>
  </div>

  <div *ngIf="!isLoading && hiddenCabinets.length === 0" class="no-items">
    <div class="no-items-message">
      <mat-icon>visibility_off</mat-icon>
      <span>No hidden cabinets found</span>
    </div>
  </div>

  <div *ngIf="!isLoading && hiddenCabinets.length > 0" class="cabinets-list">
    <div class="cabinet-item" *ngFor="let cabinet of hiddenCabinets; trackBy: trackById">
      <div class="cabinet-name">
        <mat-icon class="cabinet-icon">inventory_2</mat-icon>
        <span>{{cabinet.name}}</span>
      </div>
      <div class="actions">
        <button mat-button class="restore-button" (click)="restoreCabinet(cabinet)" matRipple>
          <mat-icon>restore</mat-icon>
          <span>Restore</span>
        </button>
      </div>
    </div>
  </div>
</div>
